<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Academics Calender</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Academics Calender</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="calender ptb--100  horizontal--tab">
  <div class="container">
    <div class="row row-cols-lg-4 row-cols-md-3 row-cols-2">
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender Term -II 2024-2025</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/academic-calenders/academic-calendar-term-II-2024-25.pdf"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender Term -I 2024-2025</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/academic-calenders/academic-calendar-term-I-2024-25.pdf"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2024-2025</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/academic-calenders/academic-calendar-2024-2025.pdf"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2023-2024</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/academic-calenders/academic-calendar-2023-24.pdf"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2023-2024</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/academic-calenders/Academic-Calendar2023-24.pdf"
              class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2022-23</h4>
            <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/academic-calender-22.pdf" class="cmn-button"
              target="_blank">Click Here</a>
            <!-- <a href="https://drive.google.com/file/d/1FAg56FI6ZXKnkwAJNbBP_V4_DK8v9CmZ/view" class="cmn-button" target="_blank">Click Here</a>               -->
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2021-22</h4>
            <a href="https://drive.google.com/file/d/1iEU9ye6JkaC7RgQp-2ejneiqCgzZwacH/view" class="cmn-button"
              target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2020-21</h4>
            <a href="https://drive.google.com/file/d/1KJNfvb39e_eQZXdt3YSdIdZ5nUZbnHZy/view" class="cmn-button"
              target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender 2019-20</h4>
            <a href="https://drive.google.com/file/d/1Dh2yM1x5KdS0qPeps-yA7t0tsISbhLkF/view" class="cmn-button"
              target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Academic Calender</h4>
            <a href="https://urlzs.com/Mwr5Z" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
